<div class="add-note-dialog-container">
    <div class="Order-dialog-header-container">
        <div>  <p class="add-note-dialog-header-text add-note-section-headers">Order Note</p></div>
        <div><p class="add-note-dialog-sub-heading">Add a note to this order</p></div>
    </div>

        <div class="add-note-dialog-container">
                <textarea  [value]="note" (input)="onInputChange($event)"  class="add-note-text-aria" name="note" rows="4" cols="50" wrap="soft"></textarea>
        </div>
 
    <div class="order-note-btn-dialog-container">

            <button class="cancel-note-dialog-btn" mat-flat-button type="button" (click)="cancelAddingNote()">
                <div class="cancel-alt-btn-content">
                    <span><p class="cancel-alt-btn-text">CANCEL</p></span>
                </div>
            </button>

            <button class="add-order-note-btn" mat-flat-button type="button" (click)="createNewOrderNote()">
                <div class="add-order-note-btn-content">
                    <img src="../../../../../assets/order-to-cash-icons/add_icon.svg" alt="Add Icon" class="add-order-note-icon">
                    <span><p class="add-order-note-btn-text">ADD NOTE</p></span>
                </div>
            </button>
    </div>

</div>
